<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 设置中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    个人设置
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <CardBox mTitle="地图显示设置">
                <!-- <template v-slot:titleRight>右侧标题</template> -->
                <template v-slot:content>
                    <el-form ref="mapForm" class="mapElFrom" :model="mapForm" label-width="100px">
                        <el-form-item label="地图中心点">
                            <el-input v-model="mapForm.centerLocation"></el-input>
                        </el-form-item>
                        <el-form-item label="地图层级">
                            <el-input v-model="mapForm.zIndex"></el-input>
                        </el-form-item>
                        <div class="map" id="map"></div>
                        <el-form-item>
                            <el-button type="primary">保存设置</el-button>
                            <el-button>取消</el-button>
                        </el-form-item>
                    </el-form>
                </template>
            </CardBox>

            <CardBox mTitle="报警推送设置">
                <!-- <template v-slot:titleRight>右侧标题</template> -->
                <template v-slot:content>
                    <el-form
                        ref="alarmForm"
                        class="alarmForm"
                        :model="alarmForm"
                        label-width="100px"
                    >
                        <el-form-item label="短信">
                            <div class="inline">
                                <el-input v-model="alarmForm.sms" class="input"></el-input>
                                <el-switch
                                    v-model="alarmForm.smsStatus"
                                    active-text="打开"
                                    inactive-text="关闭"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                ></el-switch>
                            </div>
                        </el-form-item>
                        <el-form-item label="邮箱">
                            <div class="inline">
                                <el-input v-model="alarmForm.email" class="input"></el-input>
                                <el-switch
                                    v-model="alarmForm.emailStatus"
                                    active-text="打开"
                                    inactive-text="关闭"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                ></el-switch>
                            </div>
                        </el-form-item>
                        <el-form-item label="公众号">
                            <div class="inline">
                                <el-input v-model="alarmForm.emsCnpl" class="input"></el-input>
                                <el-switch
                                    v-model="alarmForm.emsCnplStatus"
                                    active-text="打开"
                                    inactive-text="关闭"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                ></el-switch>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary">保存设置</el-button>
                            <el-button>取消</el-button>
                        </el-form-item>
                    </el-form>
                </template>
            </CardBox>
 
            <CardBox mTitle="修改密码">
                <template v-slot:titleRight>
                    <el-radio-group v-model="changePasswordType" @change="changePasswordTypeEvent">
                        <el-radio-button label="1">密码</el-radio-button>
                        <el-radio-button label="2">验证码</el-radio-button>
                    </el-radio-group>
                </template>
                <template v-slot:content>
                    <el-form
                        ref="passwordFormtype1"
                        class="alarmForm"
                        :model="passwordFormtype1"
                        label-width="100px"
                        v-if="changePasswordType==1"
                    >
                        <el-form-item label="原密码">
                            <div class="inline">
                                <el-input
                                    type="password"
                                    v-model="passwordFormtype1.oldPassword"
                                    class="input"
                                ></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="新密码">
                            <div class="inline">
                                <el-input
                                    type="password"
                                    v-model="passwordFormtype1.newPassword1"
                                    class="input"
                                ></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="新密码">
                            <div class="inline">
                                <el-input
                                    type="password"
                                    v-model="passwordFormtype1.newPassword2"
                                    class="input"
                                ></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary">保存设置</el-button>
                            <el-button>取消</el-button>
                        </el-form-item>
                    </el-form>

                    <el-form
                        ref="passwordFormtype2"
                        class="alarmForm"
                        :model="passwordFormtype2"
                        label-width="100px"
                        v-if="changePasswordType==2"
                    >
                        <el-form-item label="验证码">
                            <div class="inline">
                                <el-input v-model="passwordFormtype2.emscode" class="input"></el-input>
                                <el-button type="primary" :loading="true">获取验证码</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="新密码">
                            <div class="inline">
                                <el-input
                                    type="password"
                                    v-model="passwordFormtype2.newPassword1"
                                    class="input"
                                ></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="新密码">
                            <div class="inline">
                                <el-input
                                    type="password"
                                    v-model="passwordFormtype2.newPassword2"
                                    class="input"
                                ></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary">保存设置</el-button>
                            <el-button>取消</el-button>
                        </el-form-item>
                    </el-form>
                </template>
            </CardBox>

            <CardBox mTitle="个人资料">
                <!-- <template v-slot:titleRight>右侧标题</template> -->
                <template v-slot:content>
                    <el-form
                        ref="userInfoForm"
                        class="alarmForm"
                        :model="userInfoForm"
                        label-width="100px"
                    >
                        <el-form-item label="头像">
                            <div class="inline">
                                <div class="input">
                                     <img class="userImg" src="@/assets/centerI.png"></img>
                                </div>
                                 <el-button type="primary" :loading="false">更换头像</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="姓名">
                            <div class="inline">
                                <el-input v-model="userInfoForm.name" class="input"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="用户名">
                            <div class="inline">
                                <el-input v-model="userInfoForm.username" class="input"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <div class="inline">
                                <el-input v-model="userInfoForm.phone" class="input"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary">保存设置</el-button>
                            <el-button>取消</el-button>
                        </el-form-item>
                    </el-form>
                </template>
            </CardBox>
        </div>
    </div>
</template>

<script>
import CardBox from '../common/cardBox';
export default {
    data() {
        return {
            // 地图显示设置的数据
            mapForm: {
                centerLocation: '108.95969695176115,34.27021688474843',
                zIndex: '15'
            },
            // 报警推送设置
            alarmForm: {
                sms: '17391856792',
                email: '125161837@qq.com',
                emsCnpl: '圣豆电子',
                smsStatus: false,
                emailStatus: false,
                emsCnplStatus: false
            },
            // 修改密码类型   1为原密码修改 2为短信验证修改
            changePasswordType: 1,
            // 原密码修改密码
            passwordFormtype1: {
                oldPassword: '',
                newPassword1: '',
                newPassword2: ''
            },
            // 验证码修改密码
            passwordFormtype2: {
                emscode: '',
                newPassword1: '',
                newPassword2: ''
            },
            // 个人资料设置
            userInfoForm:{
                name:'',
                username:'',
                phone:''
            },
        };
    },
    created() {},
    mounted() {
        // 地图操作
        this.buildMap();
    },
    methods: {
        // 修改密码类型改变
        changePasswordTypeEvent(e) {
            this.changePasswordType = e;
        },
        // 构建地图
        buildMap() {
            var map = new BMapGL.Map('map');
            var point = new BMapGL.Point(108.953349, 34.270743);
            map.centerAndZoom(point, 15);
            map.enableScrollWheelZoom(true);
            var scaleCtrl = new BMapGL.ScaleControl(); // 添加比例尺控件
            map.addControl(scaleCtrl);
            var zoomCtrl = new BMapGL.ZoomControl(); // 添加缩放控件
            map.addControl(zoomCtrl);
            var cityCtrl = new BMapGL.CityListControl(); // 添加城市列表控件
            map.addControl(cityCtrl);

            this.setCustomControlClass(map, BMAP_ANCHOR_TOP_RIGHT, 435, 235, require('@/assets/centerI.png'), '重置地图', function(e) {
                // 重置地图中心点
                map.reset();
            });
            map.addEventListener('moveend', e => {
                console.log(e);
                const centerPoints = map.getCenter();
                console.log(centerPoints);
                console.log(map);
                const level = map.getZoom();
                console.log(level);

                this.mapForm.centerLocation = centerPoints.lng + ',' + centerPoints.lat;
                this.mapForm.zIndex = level.toFixed();
            });
        },

        // 自定义增加地图控件
        setCustomControlClass(map, defaultAnchor, defaultOffsetWidth, defaultOffsetHeight, imgSrc, title, domOpts) {
            // 定义一个地图重置控件类
            function ResetMapControl() {
                // 默认停靠位置和偏移量
                this.defaultAnchor = defaultAnchor;
                this.defaultOffset = new BMapGL.Size(defaultOffsetWidth, defaultOffsetHeight);
            }
            // 通过JavaScript的prototype属性继承于BMap.Control
            ResetMapControl.prototype = new BMapGL.Control();
            // 自定义控件必须实现自己的initialize方法,并且将控件的DOM元素返回
            // 在本方法中创建个div元素作为控件的容器,并将其添加到地图容器中
            ResetMapControl.prototype.initialize = function(map) {
                // 创建一个DOM元素
                let div1 = document.createElement('img');
                // 设置样式
                div1.style.height = '30px';
                div1.style.width = '30px';
                div1.src = imgSrc;
                div1.style.padding = '3px';
                div1.style.boxSizing = 'border-box';
                div1.title = title;
                // 绑定事件,重置地图
                div1.onclick = domOpts;
                // 添加DOM元素到地图中
                map.getContainer().appendChild(div1);
                // 将DOM元素返回
                return div1;
            };
            // 创建控件
            let resetMapCtrl = new ResetMapControl();
            // 添加到地图当中
            map.addControl(resetMapCtrl);
        }
    },
    components: {
        CardBox
    }
};
</script>

<style lang="less" scoped>
.mapElFrom {
    width: 500px;
}
.listBox {
    width: 600px;
}
.collapseTitle {
    font-size: 0.5rem;
}

.curson {
    cursor: pointer;
}
.map {
    width: 900px;
    height: 500px;
    margin-bottom: 20px;
}
.mrt {
    margin-top: 20px;
}

.alarmForm {
    width: 500px;
    .inline {
        display: flex;
        align-items: center;
        .input {
            width: 200px;
            margin-right: 10px;
        }
    }
}

.userImg{
    width: 100px;
    height: 100px;
    border-radius: 50%;
}
</style>